// extracted by mini-css-extract-plugin
export default {"rowWrapper":"quote-base-exworks_rowWrapper__vrtaP"};